import { render } from "./tourPost.vue?vue&type=template&id=4eaff5a4"
import script from "./tourPost.vue?vue&type=script&lang=js"
export * from "./tourPost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__